import request from "@/utils/request.js";

/**
 * 获取用户列表
 */
export function getAccounts(params) {
  return request({
    url: "/accounts",
    method: "get",
    params
  });
}
/**
 * 创建用户
 */
export function addAccount(data) {
  return request({
    url: "/accounts",
    method: "post",
    data
  });
}
/**
 * 获取用户信息
 */
export function getAccount(id) {
  return request({
    url: `/accounts/${id}`,
    method: "get"
  });
}
/**
 * 编辑用户信息
 */
export function editAccount(id, data) {
  return request({
    url: `/accounts/${id}`,
    method: "put",
    data
  });
}
/**
 * 删除用户信息
 */
export function deleteAccount(id) {
  return request({
    url: `/accounts/${id}`,
    method: "delete"
  });
}
/**
 * 修改用户密码
 */
export function editAccountPassword(id, data) {
  return request({
    url: `/accounts/${id}/password`,
    method: "post",
    data
  });
}
/**
 * 修改用户权限
 */
export function editAccountRole(id, data) {
  return request({
    url: `/accounts/${id}/role`,
    method: "put",
    data
  });
}
/**
 * 获取角色列表
 */
export function getRoles() {
  return request({
    url: "/roles",
    method: "get"
  });
}
/**
 * 创建角色
 */
export function addRole(data) {
  return request({
    url: "/roles",
    method: "post",
    data
  });
}
/**
 * 编辑角色
 */
export function editRole(id, data) {
  return request({
    url: `/roles/${id}`,
    method: "put",
    data
  });
}
/**
 * 删除角色
 */
export function deleteRole(id) {
  return request({
    url: `/roles/${id}`,
    method: "delete"
  });
}
/**
 * 获取权限树
 */
export function getPermissions() {
  return request({
    url: "/permissions",
    method: "get"
  });
}
/**
 * 创建权限
 */
export function addPermission(data) {
  return request({
    url: "/permissions",
    method: "post",
    data
  });
}
/**
 * 编辑权限
 */
export function editPermission(id, data) {
  return request({
    url: `/permissions/${id}`,
    method: "put",
    data
  });
}
/**
 * 删除权限
 */
export function deletePermission(id) {
  return request({
    url: `/permissions/${id}`,
    method: "delete"
  });
}
/**
 * 修改用户状态
 */
export function departUser(id, data) {
  return request({
    url: `/accounts/${id}/depart`,
    method: "put",
    data
  });
}
/**
 * 获取个人信息
 */
export function getUserInfo() {
  return request({
    url: `/accounts/user-profile`,
    method: "get"
  });
}
/**
 * 编辑个人信息
 */
export function editUserInfo(data) {
  return request({
    url: `/accounts/user-profile`,
    method: "put",
    data
  });
}
